module.exports = window["wc_stripe"];